import React from "react";

function NoResults() {
  return (
    <p className="section-title-home">
      NO PRODUCTS WERE FOUND MATCHING YOUR SELECTION.
      <br /> PLEASE TRY AGAIN.
    </p>
  );
}

export default NoResults;
